if (!customElements.get('nv-cart-discount')) {
  class NvCartDiscount extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      this.message = this.querySelector('[data-discount-message]');
      this.onChange = event => { event.stopPropagation(); this.apply(this.input.checked); };
      this.input?.addEventListener('change', this.onChange);
    }
    disconnectedCallback() { this.input?.removeEventListener('change', this.onChange); }
    static codes(cart) {
      const codes = new Set((cart.discount_codes || []).map(item => item.code));
      const apps = [...(cart.cart_level_discount_applications || []),...(cart.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(a => a.discount_application))];
      apps.filter(a => a?.type === 'discount_code').forEach(a => codes.add(a.title));
      return [...codes].filter(Boolean);
    }
    async apply(wanted) {
      if (NvCartDiscount.busy) { this.input.checked = this.dataset.applied === 'true'; return; }
      NvCartDiscount.busy = true;
      document.body.classList.add('nv-discount-pending');
      const wasApplied = this.dataset.applied === 'true';
      const context = this.closest('cart-drawer') ? 'drawer' : 'page';
      const checkouts = [...document.querySelectorAll('.cart__checkout-button')].map(button => ({button, disabled:button.disabled}));
      const root = window.Shopify?.routes?.root || '/';
      this.setAttribute('aria-busy','true');
      this.message.hidden = true;
      document.querySelectorAll('nv-cart-discount input').forEach(input => input.disabled = true);
      checkouts.forEach(({button}) => button.disabled = true);
      try {
        const currentResponse = await fetch(root+'cart.js',{headers:{'Accept':'application/json'}});
        if (!currentResponse.ok) throw new Error('cart-read');
        const current = await currentResponse.json();
        const codes = NvCartDiscount.codes(current).filter(code => code.toLowerCase() !== this.dataset.code.toLowerCase());
        if (wanted) codes.push(this.dataset.code);
        const fullFooter = document.getElementById('main-cart-footer');
        const fullItems = document.getElementById('main-cart-items');
        const sections = ['cart-drawer','cart-icon-bubble'];
        if (fullFooter?.dataset.id) sections.push(fullFooter.dataset.id);
        if (fullItems?.dataset.id) sections.push(fullItems.dataset.id);
        const response = await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({discount:codes.join(','),sections,sections_url:window.location.pathname})});
        const cart = await response.json();
        if (!response.ok || cart.errors) throw new Error('cart-update');
        const parser = new DOMParser();
        const drawerHtml = cart.sections?.['cart-drawer'];
        const parsedDrawer = drawerHtml ? parser.parseFromString(drawerHtml,'text/html') : null;
        if (!parsedDrawer?.querySelector('#CartDrawer')) { window.location.reload(); return; }
        const applied = parsedDrawer.querySelector('nv-cart-discount')?.dataset.applied === 'true';
        const host = document.querySelector('cart-drawer');
        if (host?.classList.contains('active')) {
          host.renderContents(cart);
        } else if (host) {
          host.querySelector('#CartDrawer').innerHTML = parsedDrawer.querySelector('#CartDrawer').innerHTML;
          host.querySelector('#CartDrawer-Overlay')?.addEventListener('click',()=>host.close());
          const bubble = document.getElementById('cart-icon-bubble');
          const bubbleHtml = cart.sections?.['cart-icon-bubble'];
          if (bubble && bubbleHtml) bubble.innerHTML = parser.parseFromString(bubbleHtml,'text/html').querySelector('.shopify-section').innerHTML;
        }
        for (const target of [fullFooter,fullItems]) {
          const html = target?.dataset.id && cart.sections?.[target.dataset.id];
          if (html) { const source = parser.parseFromString(html,'text/html').getElementById(target.id); if(source) target.innerHTML = source.innerHTML; }
        }
        const control = document.querySelector(context === 'drawer' ? 'cart-drawer nv-cart-discount' : '#main-cart-footer nv-cart-discount');
        if (wanted && !applied && control) {
          control.querySelector('[data-discount-message]').textContent = this.dataset.unavailable;
          control.querySelector('[data-discount-message]').hidden = false;
        }
        control?.querySelector('input')?.focus({preventScroll:true});
      } catch(error) {
        if(this.input) this.input.checked = wasApplied;
        this.message.textContent = this.dataset.error;
        this.message.hidden = false;
      } finally {
        NvCartDiscount.busy = false;
        document.body.classList.remove('nv-discount-pending');
        document.querySelectorAll('nv-cart-discount').forEach(control => {control.removeAttribute('aria-busy');const input=control.querySelector('input');if(input)input.disabled=false;});
        checkouts.forEach(({button,disabled})=>{if(button.isConnected)button.disabled=disabled;});
      }
    }
  }
  customElements.define('nv-cart-discount',NvCartDiscount);
  let preview;
  const syncPreview=()=>{
    const rect=preview?.getBoundingClientRect();
    const visible=rect&&rect.height>0&&getComputedStyle(preview).display!=='none';
    const height=visible?(rect.height>window.innerHeight/2?(matchMedia('(max-width:749px)').matches?68:64):rect.height):0;
    document.documentElement.style.setProperty('--nv-cart-preview-offset',height+'px');
  };
  const resize=new ResizeObserver(syncPreview);
  const connectPreview=()=>{const frame=document.getElementById('PBarNextFrame');if(frame&&frame!==preview){if(preview)resize.unobserve(preview);preview=frame;resize.observe(frame);}syncPreview();};
  new MutationObserver(connectPreview).observe(document.body,{childList:true});
  window.addEventListener('resize',syncPreview);
  connectPreview();
}
